import styled from 'styled-components';

const StyledText = styled.span`
	display: flex;
	align-items: center;
	font-family: 'GT Walsheim Pro';
	font-size: 12px;
	color: #ffffff;
`;

export { StyledText };
